export default __webpack_public_path__ + "9d3c90e00dff1daa415ea8d7e6638ddc.svg";